import React, { memo, useContext, useEffect, useMemo, useState } from 'react';
import { Checkbox } from '@yme/atoms/checkbox';
import { MobileDropdownSlider } from '@yme/atoms/mobile-dropdown-slider';
import { FilterContextMobile } from '@yme/molecules/filter-dropdown/filterContextMobile';
import { ModalWindowFooterStyled } from '@yme/molecules/filter-dropdown/styled';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { buildKey } from '@yme/utils/common';
import { MAX_MOBILE_LIST_HEIGHT } from './constants';
import { hasChangedFields, setCheckedCheckboxes, setCheckedOptionsNames, setDefaultCheckboxesOptions, } from './helpers';
import { FilterItemMobileStyled, FilterListStyled } from './styled';
export const CheckboxesDropdownMobile = memo(({ filterOptions, isRightToLeft, label, commonLabels, counts = [], id = '' }) => {
    const [optionsState, setOptionsState] = useState([]);
    const { addDynamicContextField, dynamicContextFields, currentFilter, setCurrentFilter } = useContext(FilterContextMobile);
    const currentElement = dynamicContextFields.find((item) => item.name === label);
    const isSomeOptionsChecked = useMemo(() => optionsState.some((option) => option.checked), [optionsState]);
    const isOptionsTouched = useMemo(() => dynamicContextFields.some((item) => item.name === label && item.value.length > 0), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dynamicContextFields]);
    const isChangedElements = useMemo(() => hasChangedFields(optionsState, currentElement?.value), [optionsState, currentElement?.value]);
    const onOptionChange = (e) => {
        setOptionsState((prev) => prev.map((item) => ({
            ...item,
            checked: item.name === e.target.value ? !item.checked : item.checked,
        })));
    };
    const onFilterClose = () => {
        setCurrentFilter('');
        setOptionsState(setCheckedCheckboxes(optionsState, currentElement?.value));
    };
    const onFilterSubmit = () => {
        addDynamicContextField({
            name: label,
            value: setCheckedOptionsNames(optionsState),
            id,
        });
        setCurrentFilter('');
    };
    useEffect(() => {
        const checkedData = dynamicContextFields?.find((item) => item.name === label);
        if (checkedData) {
            const data = setDefaultCheckboxesOptions(filterOptions, checkedData);
            setOptionsState(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dynamicContextFields]);
    useEffect(() => {
        const data = filterOptions.map((item) => ({
            name: item,
            checked: false,
        }));
        setOptionsState(data);
    }, [filterOptions, filterOptions.length]);
    useEffect(() => {
        if (!dynamicContextFields.length) {
            const data = filterOptions.map((item) => ({
                name: item,
                checked: false,
            }));
            setOptionsState(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dynamicContextFields]);
    const checkboxesList = optionsState.map((item, index) => (React.createElement(FilterItemMobileStyled, { key: buildKey(item.name, index) },
        React.createElement(Checkbox, { onChange: onOptionChange, value: item.name, checked: item.checked }),
        Boolean(counts.length) && (React.createElement(RegularTextLevel4, { as: "span", color: colorCoreBlack300 }, counts[index])))));
    const filterFooter = (React.createElement(ModalWindowFooterStyled, { cancelButtonLabel: commonLabels.common_cancel_button, onHide: onFilterClose, onSubmit: onFilterSubmit, submitButtonLabel: commonLabels.common_confirm_button, isSubmitButtonDisabled: (!isSomeOptionsChecked && !isOptionsTouched) || !isChangedElements }));
    return (React.createElement(MobileDropdownSlider, { title: label, isActive: currentFilter === label, handleActiveMobileSlider: onFilterClose, footerComponent: filterFooter, isResetContentPadding: true },
        React.createElement(FilterListStyled, { isMobileMode: true, isScrollable: true, isRightToLeft: isRightToLeft, maxHeight: MAX_MOBILE_LIST_HEIGHT }, checkboxesList)));
});
CheckboxesDropdownMobile.displayName = 'CheckboxesDropdownMobile';
